var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStockCrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C3.55228 3 4 3.44772 4 4V37H7V36C7 35.4477 7.44772 35 8 35C8.55228 35 9 35.4477 9 36V37H12V36C12 35.4477 12.4477 35 13 35C13.5523 35 14 35.4477 14 36V37H17V36C17 35.4477 17.4477 35 18 35C18.5523 35 19 35.4477 19 36V37H22V36C22 35.4477 22.4477 35 23 35C23.5523 35 24 35.4477 24 36V37H27V36C27 35.4477 27.4477 35 28 35C28.5523 35 29 35.4477 29 36V37H32V36C32 35.4477 32.4477 35 33 35C33.5523 35 34 35.4477 34 36V37H37C37.5523 37 38 37.4477 38 38C38 38.5523 37.5523 39 37 39H3C2.44772 39 2 38.5523 2 38V4C2 3.44772 2.44772 3 3 3Z",
    fill: "#006FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4858 30.8742C33.9685 30.6059 34.1425 29.9971 33.8743 29.5144L29.4458 21.5431C28.9167 20.5907 27.9128 20 26.8233 20H24.6769C24.3137 20 23.9791 19.8031 23.8028 19.4856L20.2028 13.0057C19.4868 11.7169 17.9406 11.1394 16.5551 11.6432L14.1346 12.5234C13.7014 12.6809 13.2165 12.5219 12.9608 12.1383L9.83216 7.4453C9.5258 6.98577 8.90493 6.8616 8.44541 7.16795C7.98588 7.4743 7.8617 8.09517 8.16806 8.5547L11.2967 13.2477C12.0639 14.3984 13.5183 14.8756 14.8181 14.403L17.2386 13.5228C17.7004 13.3549 18.2158 13.5474 18.4545 13.977L22.0544 20.4569C22.5835 21.4093 23.5874 22 24.6769 22H26.8233C27.1865 22 27.5211 22.1969 27.6975 22.5144L32.1259 30.4856C32.3942 30.9684 33.003 31.1424 33.4858 30.8742Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockCrash);
export default __webpack_public_path__ + "static/media/stock-crash.e9f31ef9fee4b1f0b2821cf8a59a2003.svg";
export { ForwardRef as ReactComponent };